import React from "react";
import PieChartSvg from "./PieChartSvg";
import { colorOf } from "./comparatiiMetrics";

const card = "rounded border border-slate-200 bg-white p-4 shadow-sm";

export function DistributieCard({ label, pieData, total }) {
  return (
    <div data-testid="comparatii-pie-card" className={card}>
      <div className="mb-3 flex items-center justify-between text-sm">
        <span className="font-semibold text-slate-700">{label} - distributie</span>
        <span className="text-xs text-slate-500">Total: <b data-testid="comparatii-total" className="text-slate-900">{total}</b></span>
      </div>
      <div className="h-96">
        {pieData.length === 0
          ? <div className="flex h-full items-center justify-center text-sm text-slate-400">Nu exista date pentru intervalul selectat</div>
          : <PieChartSvg data={pieData} total={total} colorOf={colorOf} />}
      </div>
      {pieData.length > 0 && (
        <div className="mt-2 flex flex-wrap justify-center gap-x-3 gap-y-1 text-xs text-slate-600">
          {pieData.map((d, i) => (
            <span key={d.name} className="inline-flex items-center gap-1">
              <span className="inline-block h-2.5 w-2.5 rounded-sm" style={{ background: colorOf(d.name, i) }} />{d.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export function TabelTariCard({ pieData, total }) {
  return (
    <div data-testid="comparatii-table-card" className={card}>
      <h3 className="mb-3 text-sm font-semibold text-slate-700">Tabel detaliat pe tari</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr className="bg-slate-100">
              <th className="px-2 py-1.5 text-left font-semibold">Tara</th>
              <th className="px-2 py-1.5 text-right font-semibold">Valoare</th>
              <th className="px-2 py-1.5 text-right font-semibold">Procent</th>
            </tr>
          </thead>
          <tbody>
            {pieData.map((r, i) => (
              <tr key={r.name} data-testid={`comparatii-row-${r.name}`} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="flex items-center gap-2 px-2 py-1">
                  <span className="inline-block h-3 w-3 rounded-sm" style={{ background: colorOf(r.name, i) }} />
                  <span className="font-mono font-semibold">{r.name}</span>
                </td>
                <td className="px-2 py-1 text-right font-semibold">{r.value}</td>
                <td className="px-2 py-1 text-right">{total ? ((r.value / total) * 100).toFixed(2) : "0.00"}%</td>
              </tr>
            ))}
            <tr className="bg-slate-200 font-bold">
              <td className="px-2 py-1.5">TOTAL</td>
              <td className="px-2 py-1.5 text-right">{total}</td>
              <td className="px-2 py-1.5 text-right">100%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
